import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {EventsService} from '../../../services/events.service';
import {Action, Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as actions from '../../../store/actions';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';




@Injectable()
export class HardwareFaultLevelEffects {
  private actions$ = inject(Actions);
  private eventService = inject(EventsService);
  private store$ = inject(Store<fromStore.State>);

  constructor() {}

  GetHardwareFaultMaps$ = createEffect(() => this.actions$.pipe(
    ofType(actions.HardwareFaultLevelActionTypes.GetHardwareFaultLevels),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.eventService.getHardwareFaultLevelMaps({otp: user.otp}).pipe(
        map((res: any) => {
          if (res.result && Array.isArray(res.msg.data)) {
            return new actions.LoadHardwareFaultLevels(res.msg.data);
          } else {
            return new actions.GetHardwareFaultLevelFails();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new actions.GetHardwareFaultLevelFails());
        })
      );
    })
  ));
}
